import Skeleton from 'react-loading-skeleton';

import React, { PureComponent } from 'react';
import { range } from 'lodash';

type Props = {
  count: number;
};

class HotelFullDetailItemLoading extends PureComponent<Props> {
  render() {
    let items = range(0, this.props.count);
    return (
      <>
        {items.map(i => {
          return (
            <div className="col-12" key={i}>
              <div className="border-top-light pt-30">
                <div className="row x-gap-20 y-gap-20">
                  <div className="col-md-auto">
                    <div className="cardImage ratio ratio-1:1 w-250 md:w-1/1 rounded-4">
                      <div className="cardImage__content">
                        <div className="cardImage-slider rounded-4  custom_inside-slider">
                          <Skeleton className="rounded-4 col-12 js-lazy" height={250} />
                        </div>
                      </div>
                      {/* End image */}

                      <div className="cardImage__wishlist">
                        <button className="button -blue-1 bg-white size-30 rounded-full shadow-2">
                          <i className="icon-heart text-12"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  {/* End .col */}

                  <div className="col-md">
                    <h3 className="text-18 lh-16 fw-500">
                      <Skeleton count={2} />
                    </h3>

                    <div className="row x-gap-10 y-gap-10 items-center pt-10">
                      <div className="col-auto">
                        <Skeleton width={300} />
                      </div>

                      <div className="col-auto">
                        <button data-x-click="mapFilter" className="d-block text-14 text-blue-1 underline">
                          <Skeleton />
                        </button>
                      </div>

                      <div className="col-12">
                        <Skeleton width={200} />
                      </div>
                      <div className="col-12">
                        <Skeleton />
                      </div>

                      <div className="row x-gap-10 y-gap-10 pt-10">
                        <div className="col-auto">
                          <Skeleton className="border-light rounded-100 py-5 px-20 text-14 lh-14"></Skeleton>
                        </div>

                        <div className="col-auto">
                          <Skeleton className="border-light rounded-100 py-5 px-20 text-14 lh-14"></Skeleton>
                        </div>

                        <div className="col-auto">
                          <Skeleton className="border-light rounded-100 py-5 px-20 text-14 lh-14"></Skeleton>
                        </div>

                        <div className="col-auto">
                          <Skeleton className="border-light rounded-100 py-5 px-20 text-14 lh-14"></Skeleton>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* End .col-md */}

                  <div className="col-md-auto text-right d-flex justify-content-between flex-column">
                    <Skeleton width={70} height={50} />

                    <Skeleton width={150} className="button -md mt-24" />
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </>
    );
  }
}

export default HotelFullDetailItemLoading;
